import { render, staticRenderFns } from "./CellRendererGender.vue?vue&type=template&id=c6dc5b12&"
import script from "./CellRendererGender.vue?vue&type=script&lang=js&"
export * from "./CellRendererGender.vue?vue&type=script&lang=js&"
import style0 from "./CellRendererGender.vue?vue&type=style&index=0&id=c6dc5b12&prod&lang=scss&scpoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports